// Function to remove flashes after Ajax

window.flash = function flash() {
  $(document).ready(function(){
    setTimeout(function(){
      $('.alert-success').remove();
    }, 1000);
   });

  $(document).ready(function(){
    setTimeout(function(){
      $('.alert-danger').remove();
    }, 1000);
   });
};
